import React from 'react';
import { EXTERNAL_LINKS } from './../common/links';
import Copyright from './../components/Copyright';

import IcInstagram from './../assets/icon/bi-instagram.svg';
import IcSmartstore from './../assets/icon/bi-naver-store.svg';
import IcZcard from './../assets/icon/bi-zcard.svg';


const Footer = () => { 
    return (
        <footer className="footer">
            <div className="ic-btn-group">
                <a href={EXTERNAL_LINKS.INSTAGRAM} target="_blank" rel="noreferrer" className="ic-btn"><button type="button"><i className="icon"><img src={IcInstagram} alt="Instagram" className="svg" /></i></button></a>
                <a href={EXTERNAL_LINKS.SMARTSTORE} target="_blank" rel="noreferrer" className="ic-btn"><button type="button"><i className="icon"><img src={IcSmartstore} alt="NAVER Smart Store" className="svg" /></i></button></a>
                <a href={EXTERNAL_LINKS.ZCARD} target="_blank" rel="noreferrer" className="ic-btn"><button type="button"><i className="icon"><img src={IcZcard} alt="ZCARD" className="svg" /></i></button></a>
            </div>
            <Copyright />
        </footer>
    );
    
};


export default Footer;